
export class ArgKeyPair {
cod: string;
val: string;
}

